import { Routes } from '@angular/router';
import { BasicLayoutComponent } from './core/layouts/basicLayout.component';
import { RecoverPasswordComponent } from './core/recover-password/recover-password.component';
import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { ValidLoginComponent } from './core/unauthorized/valid-login.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { MontaTurmasComponent } from './modules/inscricoes/pages/monta-turmas/monta-turmas.component';
import { UsuarioAutenticadoGuard } from './shared/guards/usuario-autenticado.guard';
import { RecoverPasswordResolver } from './shared/resolver/recover-password.resolver';
import { AuthService } from './shared/services/auth.service';
import { AlteraSenhaComponent } from './core/altera-senha/altera-senha.component';

export const ROUTES: Routes = [
  // Main redirect
  { path: '', redirectTo: 'projetos', pathMatch: 'full' },
  // {
  //   path: '',
  //   component: BasicLayoutComponent,
  //   children: [
  //     { path: 'starterview', component: StarterComponent },
  //   ],
  //   canActivate: [UsuarioAutenticadoGuard],
  // },

  // App views
  {
    path: 'projetos',
    loadChildren: () => import('./modules/projeto-completo/projeto-completo.module').then(m => m.ProjetoCompletoModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'qrobras',
    loadChildren: () => import('./modules/qr-obras/qr-obras.module').then(m => m.QrObrasModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'pre-projeto',
    loadChildren: () => import('./modules/pre-projeto/pre-projeto.module').then(m => m.PreProjetoModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'cadastro',
    loadChildren: () => import('./modules/cadastro/cadastro.module').then(m => m.CadastroModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'operacao',
    loadChildren: () => import('./modules/operacao/operacao.module').then(m => m.OperacaoModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'reuniao',
    loadChildren: () => import('./modules/reuniao/reuniao.module').then(m => m.ReuniaoModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'dashboard',
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
    children: [
      {
        path: '',
        component: DashboardComponent,
      }
    ]
  },
  {
    path: 'alterar-senha',
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
    children: [
      {
        path: '',
        component: AlteraSenhaComponent,
      }
    ]
  },

  /*
  {
    path: '', component: BlankLayoutComponent,
    children: [
      { path: 'unauthorized', component: UnauthorizedComponent }
    ]
  },*/
  { path: 'login', component: UnauthorizedComponent },
  { path: 'recuperar-senha/:id', component: RecoverPasswordComponent, resolve: { recoverValid: RecoverPasswordResolver } },
  // { path: 'alterar-senha', component: AlteraSenhaComponent },
  { path: 'valid-login/soeweb-callback', component: ValidLoginComponent, data: { typeLogin: AuthService.SOEWEB_CALLBACK } },
  { path: 'valid-login/soeweb-vincular', component: ValidLoginComponent, data: { typeLogin: AuthService.SOEWEB_VINCULAR } },
  { path: 'valid-login/dropbox-callback', component: ValidLoginComponent, data: { typeLogin: AuthService.DROPBOX_CALLBACK } },
  { path: 'valid-login/dropbox-vincular', component: ValidLoginComponent, data: { typeLogin: AuthService.DROPBOX_VINCULAR } },
  
  { path: 'logout', redirectTo: 'login' },

  {
    path: 'inscricoes',
    component: BasicLayoutComponent,
    children: [{ path: 'monta-turmas', component: MontaTurmasComponent }],
    canActivate: [UsuarioAutenticadoGuard],
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./modules/tutorial/tutorial.module').then(m => m.TutorialModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  {
    path: 'suporte',
    loadChildren: () => import('./modules/chat-bot/chat-bot.module').then(m => m.ChatBotModule),
    canActivate: [UsuarioAutenticadoGuard],
    component: BasicLayoutComponent,
  },
  // Handle all other routes
  // {path: '**',  redirectTo: 'starterview'}
];
